import {autoinject} from 'aurelia-dependency-injection';
import { DataServiceBase } from "./data-service-base";
import { EntityManager, Repository } from "aurelia-orm";
import {Item, ChildItemInfo} from "../entities/entities";
import { EntityStatuses, ItemTypes } from 'core/enums';
import { SearchInfo } from 'data/entities/search-info';
import { AppRepository } from '../app-repository';

@autoinject
export class ItemDataService  {
    deleteFile(attachmentId: any): any {
		this.repository.call('deleteFile', attachmentId);
    }

	updateFile(attachment: any): any {
		this.repository.call(`updateAttachment?id=${attachment.attachmentId}&description=${attachment.description}`, attachment.id);
	}
	
	listTasks(parameters:object): any {
		return this.repository.call('list',parameters);
	}

    moveItemTo(droppedOnId: number, droppedId: number): any {
		return this.repository.find(`moveItemTo?droppedOnId=${droppedOnId}&droppedId=${droppedId}`);
    }
    moveDown(item: ChildItemInfo): any {
		return this.repository.find(`moveDown?id=${item.id}`);
    }
    moveUp(item: ChildItemInfo): any {
		return this.repository.find(`moveUp?id=${item.id}`);
    }
    getDecendants(parentId: number, code: string) {
		return this.repository.find(`getDescendants?parentId=${parentId}&code=${code}`);
    }

    repository: AppRepository;

    constructor(private entityManager: EntityManager) {
        this.repository = entityManager.getRepository(Item);
    }

	listMyTasks(): Promise<Array<ChildItemInfo>> {
		return this.repository.find("my-tasks");
	}

	moveItemAndChildren(item: Item, entityStatus: EntityStatuses) {
		return this.repository.find(`moveItemAndDescendants?id=${item.id}&entityStatusId=${entityStatus}`);
	}

    deleteItemAndChildren(item: Item) {
        return this.repository.find(`deleteItemAndDescendants?id=${item.id}`);
    }

    getChildren(id: number, entityStatusId: number) {
        return this.repository.find("children?parentId=" + id + "&entityStatusId=" + entityStatusId);
    }

	getDetails(id: number) {
		if (id === 0) return;
        return this.repository.find("details?id=" + id);
	}

	getHistoryDetails(id: number) {
		if (id === 0) return;
		return this.repository.find("history?id=" + id);
	}

    //search(searchParameters:SearchInfo ) {
    //    return this.repository.find(searchParameters);
    //}

    listTrashed(): Promise<Array<Item>> {
        return this.repository.find('list-trashed');
    }

    listArchived(): Promise<Array<Item>> {
        return this.repository.find('list-archived');
    }

    getNew(): Item {
        return this.repository.getNewEntity();
    }

    listActive(): Promise<Array<Item>> {
        return this.repository.find("list-active");
    }

     

    rejectChanges(item: Item) {
        item.setData((item as any).__cleanValues.data.entity);
    }

    findWithCriteria(criteria: any) {
        return this.repository.find(criteria);
    }

    find(number: number) {
        return this.repository.find(number);
    }
}